<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component
        :is="Component"
        v-if="!!$route.meta.keepAlive"
        v-loading.fullscreen.lock="fullscreenLoading"
        element-loading-background="rgba(0, 0, 0, 0)"
      />
    </keep-alive>
    <component
      :is="Component"
      v-if="!$route.meta.keepAlive"
      v-loading.fullscreen.lock="fullscreenLoading"
      element-loading-background="rgba(0, 0, 0, 0)"
    />
  </router-view>
</template>
<script setup>
import { inject } from "vue";
const $zeedoUtils = inject("$zeedoUtils");
const { $zStore } = $zeedoUtils();
let { useState } = $zStore;
const { fullscreenLoading } = useState(["fullscreenLoading"]);

//拉伸适配
//eslint-disable-next-line no-unused-vars
function resizeWindow() {
  // 因为设计图是带1920*1080的，但是浏览器本身带顶部工具栏，所以缩放到时候稍微更小一点，这样不会有滚动条，这个值可以选择更大些，比如2300，这样左右两边会有空白
  const myWidth = document.documentElement.clientWidth;
  const myHeight = document.documentElement.clientHeight;
  console.log(myWidth, myHeight);
  console.log(myHeight / 1350, myWidth / 3360);

  document.getElementById("app").style.transform = `scaleX(${
    myWidth / 3360
  }) scaleY(${myHeight / 1350})`;
  document.getElementById("app").style.transformOrigin = "left top";
}
//rem 适配
//eslint-disable-next-line no-unused-vars
function resetSizeRem() {
  let designSize = 1920; // 设计图尺寸
  let html = document.documentElement;
  let wW = html.clientWidth; // 窗口宽度
  let rem = wW / designSize;
  document.documentElement.style.fontSize = rem + "px";
}

//this.resetSizeRem();
//this.resizeWindow();
//window.onresize = () => {
//  if (document.documentElement.clientWidth >= 1200) {
//    this.resetSizeRem();
//  }
//  this.resizeWindow();
//};
</script>
<style lang="scss">
@import "styles/common.scss";
</style>
